<template>
  <div class="count-detail px-2">
    <div class="list mt-2 px-4 py-2">
      <div class="item" v-for="(item, index) in list" :key="index">
        <p>{{ item.date }}</p>
        <span v-if="type == 1 || type == 2"
          >{{ typeName }}{{ parseInt(item.number) }}分钟</span
        >
        <span v-else-if="type == 4"
          >{{ typeName }}{{ parseInt(item.number) }}次数</span
        >
        <span v-else> {{ typeName }}{{ item.number | fromatNum }}小时</span>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/apis'
export default {
  data() {
    return {
      empid: this.$route.query.empid,
      month: this.$route.query.month,
      typeName: this.$route.query.name,
      type: this.$route.query.type,
      list: [],
    };
  },
  created() {
    document.title = this.typeName + "统计";
    this.personDetail();
  },
  filters: {
    fromatNum(e) {
      return parseFloat(e).toFixed(2);
    },
  },
  methods: {
    // 获取考勤详情
    personDetail() {
      let data = {
        month: this.month + "-01",
        empid: this.empid,
        type: this.type,
      };
      api.personDetail(data).then((res) => {
        this.list = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.count-detail {
  @include container();
  .list {
    background: #ffffff;
    border-radius: 10px;
    min-height: 90vh;
    .item {
      @include flex-between();
      height: 88px;
      font-size: 30px;
      font-family: SimHei;
      font-weight: 500;
      border-bottom: 1px solid #dedede;

      & > p {
        color: #1e1e1e;
      }
      & > span {
        color: #ff0000;
      }
    }
    .item:not(:last-child) {
    }
  }
}
</style>